import { render, staticRenderFns } from "./CriteoStats.vue?vue&type=template&id=283a7341&"
import script from "./CriteoStats.vue?vue&type=script&lang=js&"
export * from "./CriteoStats.vue?vue&type=script&lang=js&"
import style0 from "./CriteoStats.vue?vue&type=style&index=0&id=283a7341&prod&lang=scss&"
import style1 from "./CriteoStats.vue?vue&type=style&index=1&id=283a7341&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports